var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.773 0.56213C16.4353 -0.0531654 18.0532 1.56474 17.4379 3.22703L12.624 16.2127C11.9147 18.1239 9.16331 17.9733 8.66833 15.9959C8.66832 15.9958 8.66835 15.996 8.66833 15.9959L7.3356 10.6755L1.99685 9.33445C0.0216817 8.83818 -0.129576 6.08826 1.78147 5.37991C1.78153 5.37989 1.7814 5.37993 1.78147 5.37991L14.773 0.56213ZM10.9989 15.6099L15.8124 2.62534C15.9135 2.35219 15.6481 2.08665 15.3749 2.18756C15.3748 2.18759 15.375 2.18754 15.3749 2.18756L2.38414 7.00506C2.07101 7.12109 2.09489 7.57187 2.41912 7.65338C2.41914 7.65338 2.41911 7.65338 2.41912 7.65338L8.26129 9.1209C8.57123 9.19876 8.81317 9.44086 8.89082 9.75085L10.3497 15.5747C10.4307 15.8985 10.882 15.9249 10.9989 15.6099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.aeec71b2c229e08f4f6cf864176aa84b.svg";
export { ForwardRef as ReactComponent };